import styled from 'styled-components';
import { FontSize, inputStyle, spacing } from 'commons';

const inputFontSize = FontSize.font12;

export const Wrapper = styled.label`
  display: flex;
  flex: 1;
  overflow-x: auto;
  overflow-y: hidden;
  height: ${spacing.input.height};
  border: 1px solid ${({ theme }) => theme.neutral_300};
  border-right: none;
  background-color: ${({ theme }) => theme.neutral_100};

  ::-webkit-scrollbar {
    height: 4px;
  }

  input {
    margin: 4px;
    padding: 4px;
    width: 100%;
    min-width: 140px;
    outline: none;
    border: none;
    font-size: ${inputFontSize};
    font-weight: ${inputStyle.fontWeight};

    &::placeholder {
      opacity: ${inputStyle.placeholderOpacity};
    }

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      box-shadow: inset 0 0 0 500px white;
    }
  }
`;

export const InputTags = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  padding: 8px 0;

  .input-width {
    width: 100%;
  }

  .tag {
    min-width: min-content;
  }

  div {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  span {
    position: relative;
    display: flex;
    align-items: center;
    max-width: 162px;
    padding: 4px;
    padding-right: 20px;
    margin: 5px;
    margin-right: 0;
    background-color: ${({ theme }) => theme.neutral_300};
    color: ${({ theme }) => theme.neutral_500};
    white-space: nowrap;
    font-size: ${inputFontSize};
    text-align: center;
    text-overflow: ellipsis;
    overflow: hidden;
    border-radius: 4px;
    box-sizing: border-box;

    button {
      position: absolute;
      right: 0;
      background-color: transparent;
      font-size: 16px;
      padding: 4px;
      cursor: pointer;

      &:hover {
        background-color: ${({ theme }) => theme.danger_500};
        color: ${({ theme }) => theme.neutral_100};
      }
    }
  }
`;
